import moment from "moment";
import reportAction from "../actions/reportAction";
import helpersTime from "../../helpers/time";
import WhichTypeSelect from "../../component/sections/report/constants/WhichTypeSelect";
import eventAdvertise from "../actions/eventAdvertise";
import activeChart from "../actions/activeChart";
import separationDataActive from "../actions/separationDataActive";
import ReportData from "../../component/sections/report/ReportData";

const mainState = {
  all_site_publisher: [],

  site_publisher_ID: 0,

  count_all_site_publisher: 1,
  count_all_positions: 2,
  count_view_advertise_in_position_on_site_publisher: 0,
  time_second_view_advertise_in_position_on_site_publisher: 0,
  income: 0,

  which_type_select: WhichTypeSelect.ALL_SITE_PUBLISHER,
  separation_data_chart: separationDataActive.POSITION,

  date_from: helpersTime.addStartTime(helpersTime.getLastDayDate(1)),
  date_to: helpersTime.addStartTime(moment().format("YYYY-MM-DD")),

  data_chart: [],
  data_chart_separation: {},

  active_chart: activeChart.LINE_SIMPLE,

  event_data_chart: eventAdvertise.eventAdvertiseString.VIEW,

  price: 0,
};

const getCountDayBetweenTwoDates = (dateFrom, dateTo) => {
  return helpersTime.getDifferentDates(dateFrom, dateTo);
};

const generateDataSeparationTime = (dateFrom, dateTo, view) => {
  const countDayBetweenTwoDates = getCountDayBetweenTwoDates(dateFrom, dateTo);
  const dataSeparationTime = {};
  dataSeparationTime[dateFrom] = {
    view: view,
  };
  for (let counter = 1; counter <= countDayBetweenTwoDates; counter++) {
    if (getRandomNumber(2)) {
      view = view + getRandomNumber(30);
    } else {
      view = view - getRandomNumber(30) > 0 ? view - getRandomNumber(30) : 0;
    }

    dataSeparationTime[
      helpersTime.addDate(dateFrom, counter, "d").split(" ")[0]
    ] = {
      view: view,
    };
  }
  return dataSeparationTime;
};

const getCountIncomePosition = (dateForm, dateTo, IncomeReportPosition) => {
  const countDayBetweenTwoDates = getCountDayBetweenTwoDates(dateForm, dateTo);
  return IncomeReportPosition * countDayBetweenTwoDates * 24;
};

const getTimeSecondViewPosition = (
  dateForm,
  dateTo,
  timeSecondViewReportPosition
) => {
  const countDayBetweenTwoDates = getCountDayBetweenTwoDates(dateForm, dateTo);
  return timeSecondViewReportPosition * countDayBetweenTwoDates * 24;
};

const getCountAllViewPosition = (dateForm, dateTo, countViewReportPosition) => {
  const countDayBetweenTwoDates = getCountDayBetweenTwoDates(dateForm, dateTo);
  return countDayBetweenTwoDates * countViewReportPosition * 24;
};

const getRandomNumber = (range) => {
  return Math.floor(Math.random() * range);
};

const mergeObjectsInArray = (array) => {
  let newObject = {};
  array.forEach((objectItem) => {
    for (const key in objectItem) {
      let lastVar = newObject[key] ? newObject[key] : 0;
      newObject[key] = objectItem[key] + lastVar;
    }
  });
  return newObject;
};

const generateDataSeparationTimeEachHour = (view) => {
  return {
    "00:00:00-00:59:59": view,
    "01:00:00-01:59:59": view + getRandomNumber(10),
    "02:00:00-02:59:59": view,
    "03:00:00-03:59:59": view + getRandomNumber(10),
    "04:00:00-04:59:59": view - getRandomNumber(10),
    "05:00:00-05:59:59": view + getRandomNumber(10),
    "06:00:00-06:59:59": view - getRandomNumber(10),
    "07:00:00-07:59:59": view,
    "08:00:00-08:59:59": view + getRandomNumber(10),
    "09:00:00-09:59:59": view,
    "10:00:00-10:59:59": view - getRandomNumber(10),
    "11:00:00-11:59:59": view,
    "12:00:00-12:59:59": view + getRandomNumber(10),
    "13:00:00-13:59:59": view,
    "14:00:00-14:59:59": view - getRandomNumber(10),
    "15:00:00-15:59:59": view + getRandomNumber(10),
    "16:00:00-16:59:59": view,
    "17:00:00-17:59:59": view + getRandomNumber(10),
    "18:00:00-18:59:59": view,
    "19:00:00-19:59:59": view - getRandomNumber(10),
    "20:00:00-20:59:59": view,
    "21:00:00-21:59:59": view - getRandomNumber(10),
    "22:00:00-22:59:59": view + getRandomNumber(10),
    "23:00:00-23:59:59": view - getRandomNumber(10),
  };
};

const main = (state = mainState, action) => {
  let dataChart;
  let dataChartSeparation;
  let countDayBetweenTwoDates;
  let dateForm;
  let dateTo;
  let report;
  let positions;
  let newState = state;
  let countAllViewAdvertisesInAllPositionsInWebSitePublisher = 0;
  let timeSecondViewAdvertisesInAllPositionsInWebSitePublisher = 0;
  let incomeInAllPositionsInSitePublisher = 0;
  switch (action.type) {
    case reportAction.SET_DATE_REPORT_FILTER:
      newState = {
        ...state,
        date_from: action.payload.date_from,
        date_to: action.payload.date_to,
      };
      break;

    case reportAction.GET_REPORT_ALL_WEB_SITE_PUBLISHER_SUCCESS:
      newState = {
        ...state,
        which_type_select: WhichTypeSelect.ALL_SITE_PUBLISHER,
        count_all_site_publisher: action.payload.report.count_site_publisher,

        count_all_positions:
          action.payload.report.count_all_positions_in_web_site_publisher,

        count_view_advertise_in_position_on_site_publisher:
          action.payload.report
            .count_all_view_advertises_in_all_positions_in_web_site_publisher,

        time_second_view_advertise_in_position_on_site_publisher:
          action.payload.report
            .time_second_view_advertises_in_all_positions_in_web_site_publisher,

        income: action.payload.report.income_in_all_positions_in_site_publisher,
      };
      break;

    case reportAction.GET_REPORT_WEB_SITE_PUBLISHER:
      report = ReportData.filter(
        (report) => report.site_publisher_id == state.site_publisher_ID
      );
      positions = report[0].positions;

      positions.forEach((position) => {
        countAllViewAdvertisesInAllPositionsInWebSitePublisher +=
          getCountAllViewPosition(
            state.date_from,
            state.date_to,
            position.count_view_advertise_in_position_on_site_publisher_each_hour
          );
        timeSecondViewAdvertisesInAllPositionsInWebSitePublisher +=
          getTimeSecondViewPosition(
            state.date_from,
            state.date_to,
            position.time_second_view_advertise_in_position_on_site_publisher
          );
        incomeInAllPositionsInSitePublisher += getCountIncomePosition(
          state.date_from,
          state.date_to,
          position.income_each_hour
        );
      });
      newState = {
        ...state,
        count_all_positions: positions.length,

        count_view_advertise_in_position_on_site_publisher:
          countAllViewAdvertisesInAllPositionsInWebSitePublisher,

        time_second_view_advertise_in_position_on_site_publisher:
          timeSecondViewAdvertisesInAllPositionsInWebSitePublisher,

        income: incomeInAllPositionsInSitePublisher,
      };
      break;

    case reportAction.GET_ALL_SITE_PUBLISHER_SEPARATION_DATA_CHART_FAILED:
      alert("گرفتن گزارش با مشکل روبرو شد");
      break;

    case reportAction.GET_REPORT_ALL_WEB_SITE_PUBLISHER_FAILED:
      alert("گرفتن گزارش با مشکل روبرو شد");
      break;

    case reportAction.GET_REPORT_WEB_SITE_PUBLISHER_FAILED:
      alert("گرفتن گزارش با مشکل روبرو شد");
      break;

    case reportAction.GET_REPORT_WEB_SITE_PUBLISHER_DATA_CHART:
      report = ReportData.filter(
        (report) => report.site_publisher_id == state.site_publisher_ID
      );
      positions = report[0].positions;
      dateForm = action.payload.dateFrom;
      dateTo = action.payload.dateTo;
      countDayBetweenTwoDates = getCountDayBetweenTwoDates(dateForm, dateTo);

      let dataChartArray = [];
      if (countDayBetweenTwoDates == 1) {
        positions.forEach((position) => {
          dataChartArray.push(
            generateDataSeparationTimeEachHour(
              position.time_second_view_advertise_in_position_on_site_publisher
            )
          );
        });
      } else {
        positions.forEach((position) => {
          let dataSeparationTime = generateDataSeparationTime(
            dateForm.split(" ")[0],
            dateTo.split(" ")[0],
            position.time_second_view_advertise_in_position_on_site_publisher *
              24
          );
          for (const key in dataSeparationTime) {
            dataSeparationTime[key] =
              dataSeparationTime[key].view + getRandomNumber(100);
          }
          dataChartArray.push(dataSeparationTime);
        });
      }
      newState = {
        ...state,
        data_chart: mergeObjectsInArray(dataChartArray),
        active_chart:
          helpersTime.getDifferentDates(
            action.payload.dateFrom.split("_")[0],
            action.payload.dateTo.split("_")[0]
          ) == 1
            ? activeChart.LINE_SIMPLE
            : activeChart.BAR,
      };
      break;

    case reportAction.SET_SITE_PUBLISHER_ID:
      newState = {
        ...state,
        site_publisher_ID: action.payload.site_publisher_ID,
        which_type_select: WhichTypeSelect.SPECIFIC_SITE_PUBLISHER,
      };
      break;

    case reportAction.EMPTY_SITE_PUBLISHER_DATA_SEPARATION:
      newState = {
        ...state,
        data_chart_separation: {},
      };
      break;

    case reportAction.GET_SITE_PUBLISHER_SEPARATION_DATA_CHART:
      report = ReportData.filter(
        (report) => report.site_publisher_id == state.site_publisher_ID
      );
      report = report[0];
      dateForm = action.payload.dateFrom;
      dateTo = action.payload.dateTo;
      dataChartSeparation = {};
      if (action.payload.separation == separationDataActive.POSITION) {
        report.positions.forEach((position) => {
          dataChartSeparation[position.tag_html_id] = {
            count_all_view_advertises_in_all_positions_in_web_site_publisher:
              getCountAllViewPosition(
                dateForm,
                dateTo,
                position.count_view_advertise_in_position_on_site_publisher_each_hour
              ),
            time_second_view_advertises_in_all_positions_in_web_site_publisher:
              getTimeSecondViewPosition(
                dateForm,
                dateTo,
                position.time_second_view_advertise_in_position_on_site_publisher
              ),
            income_in_all_positions_in_site_publisher: getCountIncomePosition(
              dateForm,
              dateTo,
              position.income_each_hour
            ),
          };
        });
      } else if (action.payload.separation == separationDataActive.TIME) {
        report.positions.forEach((position) => {
          let dataSeparationCountView = generateDataSeparationTime(
            dateForm.split(" ")[0],
            dateTo.split(" ")[0],
            position.count_view_advertise_in_position_on_site_publisher_each_hour
          );
          let dataSeparationTime = generateDataSeparationTime(
            dateForm.split(" ")[0],
            dateTo.split(" ")[0],
            position.time_second_view_advertise_in_position_on_site_publisher
          );
          let dataSeparationIncome = generateDataSeparationTime(
            dateForm.split(" ")[0],
            dateTo.split(" ")[0],
            position.income_each_hour
          );

          for (const key in dataSeparationCountView) {
            dataChartSeparation[key] = {
              count_all_view_advertises_in_all_positions_in_web_site_publisher:
                dataSeparationCountView[key].view,
              time_second_view_advertises_in_all_positions_in_web_site_publisher:
                dataSeparationTime[key].view,
              income_in_all_positions_in_site_publisher:
                dataSeparationIncome[key].view,
            };
          }
        });

      }
      newState = {
        ...state,
        data_chart_separation: dataChartSeparation,
      };
      break;

    case reportAction.SET_TYPE_SEPARATION_DATA_CHART:
      newState = {
        ...state,
        separation_data_chart: action.payload.separation,
      };
      break;

    case reportAction.GET_SITE_PUBLISHER_SEPARATION_DATA_CHART_FAILED:
      alert("گرفتن گزارش با مشکل روبرو شد");
      break;
  }

  return newState;
};
export default main;
